<template>
  <div class="p-4 bg-white rounded-lg h-100" v-if="isDataLoaded">
    <DataTable
      :table_state="table_state"
      :store_names="store_names"
      :assignPicking="componentForAssignPicking"
    />
  </div>
</template>

<script>
import DataTable from "@/own/components/warehouseManagement/pickingAssignment/DataTable.vue";
import AssignPicking from "@/own/components/warehouseManagement/pickingAssignment/AssignPicking.vue";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import {
  SET_TABLE_FILTER,
  SET_TABLE_PAGE,
  SET_TABLE_PERPAGE,
  SET_TABLE_SORTBY,
  UPDATE_TABLE_DATA,
  UPDATE_TABLE_STRUCTURE,
} from "@/core/services/store/pickingAssignment.module";

export default {
  name: "PickingAssignment",
  components: { DataTable },
  data: () => ({
    componentForAssignPicking: AssignPicking,
    table_state: {
      UPDATE_TABLE_STRUCTURE: UPDATE_TABLE_STRUCTURE,
      UPDATE_TABLE_DATA: UPDATE_TABLE_DATA,
      SET_TABLE_SORTBY: SET_TABLE_SORTBY,
      SET_TABLE_FILTER: SET_TABLE_FILTER,
      SET_TABLE_PERPAGE: SET_TABLE_PERPAGE,
      SET_TABLE_PAGE: SET_TABLE_PAGE,
    },
    store_names: {
      getTableFilters: "getPICKINGASSIGNMENTTableFilters",
      getTableState: "getPICKINGASSIGNMENTTableState",
      getTableData: "getPICKINGASSIGNMENTTableData",
      getTableHeaders: "getPICKINGASSIGNMENTTableHeaders",
      getTableProperties: "getPICKINGASSIGNMENTTableProperties",
      getTablePermissions: "getPICKINGASSIGNMENTTablePermissions",
    },
  }),
  methods: {
    async initTableContent() {
      await this.$store.dispatch(this.table_state.UPDATE_TABLE_STRUCTURE, {});
      await this.$store.dispatch(this.table_state.UPDATE_TABLE_DATA, {});
    },
  },
  computed: {
    isDataLoaded: function () {
      return !!this.$store.getters[this.store_names.getTableData];
    },
  },
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
    this.initTableContent();
  },
};
</script>
